import React, { useState } from "react";
import { ConfirmModal } from "../ConfirmModal/ConfirmModal";
import "./DDSiteManager.scss";

export function makeSiteId() {
  return `site-${Math.random().toString(36).slice(2, 9)}`;
}

const COUNTRIES = [
  { code: "AR", name: "Argentina" }, { code: "BO", name: "Bolivia" }, { code: "BR", name: "Brasil" },
  { code: "CL", name: "Chile" }, { code: "CO", name: "Colombia" }, { code: "CR", name: "Costa Rica" },
  { code: "CU", name: "Cuba" }, { code: "EC", name: "Ecuador" }, { code: "SV", name: "El Salvador" },
  { code: "ES", name: "España" }, { code: "US", name: "Estados Unidos" }, { code: "GT", name: "Guatemala" },
  { code: "HT", name: "Haití" }, { code: "HN", name: "Honduras" }, { code: "IN", name: "India" },
  { code: "CN", name: "China" }, { code: "BD", name: "Bangladés" }, { code: "VN", name: "Vietnam" },
  { code: "KH", name: "Camboya" }, { code: "MX", name: "México" }, { code: "NI", name: "Nicaragua" },
  { code: "PA", name: "Panamá" }, { code: "PY", name: "Paraguay" }, { code: "PE", name: "Perú" },
  { code: "DO", name: "República Dominicana" }, { code: "UY", name: "Uruguay" }, { code: "VE", name: "Venezuela" },
];

const EMPTY_FORM = { name: "", country: "", flag: "", headcount: "" };

export function DDSiteManager({ sites, onAdd, onRemove, minSites = 1, blockRemove }) {
  const [manageOpen, setManageOpen] = useState(false);
  const [formOpen, setFormOpen] = useState(false);
  const [form, setForm] = useState(EMPTY_FORM);
  const [confirm, setConfirm] = useState({ open: false, site: null });
  const [warning, setWarning] = useState("");

  const F = (key) => (e) => setForm((p) => ({ ...p, [key]: e.target.value }));

  function onCountryChange(e) {
    const name = e.target.value;
    const match = COUNTRIES.find((c) => c.name === name);
    setForm((p) => ({ ...p, country: name, flag: p.flag || match?.code || p.flag }));
  }

  function submitAdd(e) {
    e.preventDefault();
    if (!form.name.trim()) return;
    const match = COUNTRIES.find((c) => c.name === form.country);
    const flag = (form.flag || match?.code || form.country || "??").slice(0, 3).toUpperCase();
    onAdd({
      id: makeSiteId(),
      flag,
      name: form.name.trim(),
      country: form.country,
      headcount: parseInt(form.headcount, 10) || 0,
    });
    setForm(EMPTY_FORM);
    setFormOpen(false);
  }

  function requestRemove(site) {
    const blockMsg = blockRemove?.(site);
    if (blockMsg) {
      setWarning(blockMsg);
      return;
    }
    setConfirm({ open: true, site });
  }

  function closeManage() {
    setManageOpen(false);
    setFormOpen(false);
    setForm(EMPTY_FORM);
    setWarning("");
  }

  return (
    <div className="ddsm">
      <div className="ddsm-row">
        <span className="ddsm-label">Sitios</span>
        <div className="ddsm-chips">
          {sites.map((s) => (
            <span key={s.id} className="ddsm-chip">
              <span className="ddsm-chip-flag">{s.flag}</span>
              {s.name}
            </span>
          ))}
        </div>
        <button type="button" className="ddsm-btn-add" onClick={() => setManageOpen(true)}>
          ⚙ Gestionar sitios
        </button>
      </div>

      {manageOpen && (
        <div className="ddsm-modal-overlay" onClick={closeManage}>
          <div className="ddsm-modal" onClick={(e) => e.stopPropagation()}>
            <div className="ddsm-modal-hdr">
              <h3>Gestionar sitios</h3>
              <button type="button" className="ddsm-modal-close" onClick={closeManage}>✕</button>
            </div>

            <table className="ddsm-table">
              <thead>
                <tr><th>Sitio</th><th>País</th><th>Dotación</th><th /></tr>
              </thead>
              <tbody>
                {sites.map((s) => (
                  <tr key={s.id}>
                    <td><span className="ddsm-chip-flag">{s.flag}</span> {s.name}</td>
                    <td>{s.country || "—"}</td>
                    <td>{(s.headcount || 0).toLocaleString()}</td>
                    <td>
                      {sites.length > minSites && (
                        <button type="button" className="ddsm-row-del" title="Eliminar sitio" onClick={() => requestRemove(s)}>🗑</button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {warning && (
              <div className="ddsm-warning">
                {warning}
                <button type="button" onClick={() => setWarning("")}>✕</button>
              </div>
            )}

            {formOpen ? (
              <form className="ddsm-form" onSubmit={submitAdd}>
                <div className="ddsm-form-fields">
                  <input placeholder="Nombre del sitio *" value={form.name} onChange={F("name")} required autoFocus />
                  <select value={form.country} onChange={onCountryChange}>
                    <option value="">País</option>
                    {COUNTRIES.map((c) => <option key={c.code} value={c.name}>{c.name}</option>)}
                  </select>
                  <input placeholder="Código (ej. AR)" value={form.flag} onChange={F("flag")} maxLength={3} />
                  <input placeholder="Dotación" type="number" min="0" value={form.headcount} onChange={F("headcount")} />
                </div>
                <div className="ddsm-form-actions">
                  <button type="button" className="ddsm-btn-cancel" onClick={() => { setFormOpen(false); setForm(EMPTY_FORM); }}>Cancelar</button>
                  <button type="submit" className="ddsm-btn-save">Guardar sitio</button>
                </div>
              </form>
            ) : (
              <button type="button" className="ddsm-btn-add ddsm-btn-add--modal" onClick={() => setFormOpen(true)}>
                + Agregar sitio
              </button>
            )}
          </div>
        </div>
      )}

      <ConfirmModal
        open={confirm.open}
        message={`¿Eliminar el sitio "${confirm.site?.name}"? Se perderán los datos cargados para este sitio.`}
        danger
        onConfirm={() => { onRemove(confirm.site.id); setConfirm({ open: false, site: null }); }}
        onCancel={() => setConfirm({ open: false, site: null })}
      />
    </div>
  );
}
